import { thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum } from '@/gen/types/ThirdPartyEnumsHowWasTheIncidentDetectedOption';
import { thirdPartyEnumsIncidentAffectsACustomerOptionEnum } from '@/gen/types/ThirdPartyEnumsIncidentAffectsACustomerOption';
import { thirdPartyEnumsNatureOfCompromiseOptionEnum } from '@/gen/types/ThirdPartyEnumsNatureOfCompromiseOption';
import { thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum } from '@/gen/types/ThirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOption';

import { whenPathEquals, whenPathIncludes } from './conditions';
import type { IncidentFieldRule } from './types';

export const thirdPartyFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of third-party security incident is this?',
        description: 'Select the type of third-party security incident.',
        order: 90,
    },
    {
        key: 'nameOfThirdPartyOrSupplier',
        label: 'Which third party or supplier is involved?',
        description: 'Enter the name of the third party or supplier.',
        order: 100,
    },
    {
        key: 'typeOfThirdPartyServiceAffected',
        label: 'What type of third-party service is affected?',
        description: 'Describe the service provided by the third party.',
        order: 110,
    },
    {
        key: 'natureOfCompromise',
        label: 'What happened?',
        description: 'Select how the third party was compromised, e.g. breach, outage.',
        order: 120,
    },
    {
        key: 'natureOfCompromiseExplanation',
        label: 'Nature of compromise explanation',
        kind: 'textarea',
        order: 130,
        visibleWhen: whenPathIncludes('natureOfCompromise', thirdPartyEnumsNatureOfCompromiseOptionEnum.Other),
        requiredWhen: whenPathIncludes('natureOfCompromise', thirdPartyEnumsNatureOfCompromiseOptionEnum.Other),
    },
    {
        key: 'howWasTheIncidentDetected',
        label: 'How was this incident detected?',
        description: 'Select how it was discovered, e.g. alert, third-party notification.',
        order: 140,
    },
    {
        key: 'howWasTheIncidentDetectedExplanation',
        label: 'Detection explanation',
        kind: 'textarea',
        order: 150,
        visibleWhen: whenPathEquals('howWasTheIncidentDetected', thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum.Other),
        requiredWhen: whenPathEquals('howWasTheIncidentDetected', thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum.Other),
    },
    {
        key: 'wasConfidentialOrSensitiveDataInvolved',
        label: 'Was any sensitive data involved?',
        description: 'Select Yes if confidential, personal, or sensitive data was involved.',
        order: 160,
    },
    {
        key: 'typeOfConfidentialOrSensitiveData',
        label: 'What type of data was involved?',
        description: 'Select the data type, e.g. personal data, credentials, financial data.',
        order: 170,
        visibleWhen: whenPathEquals(
            'wasConfidentialOrSensitiveDataInvolved',
            thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum.Yes,
        ),
        requiredWhen: whenPathEquals(
            'wasConfidentialOrSensitiveDataInvolved',
            thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum.Yes,
        ),
    },
    {
        key: 'incidentAffectsACustomer',
        label: 'Does this affect a customer?',
        description: 'Select Yes if customer data or services were impacted.',
        order: 180,
    },
    {
        key: 'affectedCustomer',
        label: 'Affected customer',
        order: 190,
        visibleWhen: whenPathEquals('incidentAffectsACustomer', thirdPartyEnumsIncidentAffectsACustomerOptionEnum.Yes),
        requiredWhen: whenPathEquals('incidentAffectsACustomer', thirdPartyEnumsIncidentAffectsACustomerOptionEnum.Yes),
    },
    {
        key: 'thirdPartyOrSupplierStillEngagedInRemediation',
        label: 'Is the third party still working on remediation?',
        description: 'Select Yes if the third party is still investigating or resolving.',
        order: 200,
    },
    {
        key: 'thirdPartyOrSupplierProvidedAnInitialRCAOrStatement',
        label: 'Has the third party provided an initial RCA or statement?',
        description: 'Select Yes if a root cause analysis or official statement was received.',
        order: 210,
    },
];
